import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ImageConverter from './components/ImageConverter';
import AnnouncementBanner from './components/AnnouncementBanner';
import FeaturesSection from './components/FeaturesSection';
import Blog from './pages/Blog';
import BlogPost1 from './pages/BlogPost1';
import BlogPost2 from './pages/BlogPost2';
import BlogPost3 from './pages/BlogPost3';
import BlogPost4 from './pages/BlogPost4';
import BlogPost5 from './pages/BlogPost5';
import BlogPost6 from './pages/BlogPost6';
import BlogPost7 from './pages/BlogPost7';
import BlogPostHeic1 from './pages/BlogPostHeic1';
import BlogPostHeic2 from './pages/BlogPostHeic2';
import BlogPostHeic3 from './pages/BlogPostHeic3';
import Privacy from './pages/Privacy';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-200 flex flex-col font-sans">
      <Header />
      <AnnouncementBanner />
      <main className="flex-grow flex flex-col items-center p-4 sm:p-6 lg:p-8">
        {/* Converter Section */}
        <div className="w-full max-w-4xl mx-auto py-8">
          <ImageConverter />
        </div>
        {/* Features Section */}
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
        <Route path="/blog/what-is-webp-and-why-cant-i-open-it" element={<><Header /><BlogPost1 /><Footer /></>} />
        <Route path="/blog/how-to-convert-webp-to-jpg" element={<><Header /><BlogPost2 /><Footer /></>} />
        <Route path="/blog/webp-vs-jpg-which-format-to-use" element={<><Header /><BlogPost3 /><Footer /></>} />
        <Route path="/blog/how-to-open-webp-files" element={<><Header /><BlogPost4 /><Footer /></>} />
        <Route path="/blog/webp-to-png-converter" element={<><Header /><BlogPost5 /><Footer /></>} />
        <Route path="/blog/best-webp-converter" element={<><Header /><BlogPost6 /><Footer /></>} />
        <Route path="/blog/chrome-extension-webp-converter" element={<><Header /><BlogPost7 /><Footer /></>} />
        <Route path="/blog/how-to-convert-heic-to-jpg" element={<><Header /><BlogPostHeic1 /><Footer /></>} />
        <Route path="/blog/why-cant-i-open-iphone-photos" element={<><Header /><BlogPostHeic2 /><Footer /></>} />
        <Route path="/blog/share-iphone-photos-with-android" element={<><Header /><BlogPostHeic3 /><Footer /></>} />
        <Route path="/privacy" element={<><Header /><Privacy /><Footer /></>} />
      </Routes>
    </Router>
  );
};

export default App;

